module.exports = "<h2 id=\"component-description\">Component Description</h2>\n<p>A Nessie Label is a text label.</p>\n<h2 id=\"example-usage\">Example Usage</h2>\n<pre><code>&lt;Label&gt;&lt;Required&gt;Just a label&lt;/Required&gt;&lt;/Label&gt;\n</code></pre>";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader!./node_modules/markdown-loader!./src/Label/README.md
// module id = 360
// module chunks = 0